import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiGatewayHelperService } from "modules/app/services/apigateway-helper.service";
import { Observable } from "rxjs";

@Injectable()
export class CreateUserAnalyticsService {
    private createUAMetadata: any = {
        userId: '',
        orgId: '',
        redirectRoute: ''
    }
    constructor(
        private http: HttpClient,
        private apiGatewayHelperService: ApiGatewayHelperService,
    ) { }

    setUAMetadata(userId, orgId, pubnubEventType, redirectRoute) {
        this.createUAMetadata.userId = userId;
        this.createUAMetadata.orgId = orgId;
        this.createUAMetadata.pubnubEventType = pubnubEventType;
        this.createUAMetadata.redirectRoute = redirectRoute;
    }

    getUAMetadata() {
        return this.createUAMetadata;
    }

    userProductEntitlement(spaceId, productCode): Observable<any> {

        return this.http.get(this.apiGatewayHelperService.getApiGatewayPrefixUrl() + spaceId + '/create-user-analytics/product/' + productCode);
    }
}